import { render, staticRenderFns } from "./y_choose_color.vue?vue&type=template&id=655f627a"
import script from "./y_choose_color.vue?vue&type=script&lang=js"
export * from "./y_choose_color.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports